import { render } from "./SellerBlock.vue?vue&type=template&id=30965c07"
import script from "./SellerBlock.vue?vue&type=script&lang=js"
export * from "./SellerBlock.vue?vue&type=script&lang=js"

import "./SellerBlock.vue?vue&type=style&index=0&id=30965c07&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__